// Project modules
import {
	CompaniesState,
} from '@localTypes/company';
import {
	CompanyBuildingsState,
} from '@localTypes/companyBuildings';
import {
	CompanyManagersState,
} from '@localTypes/companyManagers';
import {
	appReducer,
	AppState,
} from '@stores/_slices/app';
import {
	companiesReducer,
} from '@stores/_slices/companies';
import {
	companyBuildingsReducer,
} from '@stores/_slices/companyBuildings';
import {
	companyManagersReducer,
} from '@stores/_slices/companyManagers';
import {
	demandsReducer,
	StoreDemands,
} from '@stores/_slices/demands';
import {
	deviceReducer,
	DeviceSliceInstance,
} from '@stores/_slices/device';
import {
	mapReducer,
	MapSliceInstance,
} from '@stores/_slices/map';
import {
	matchingOffersDemandsReducer,
	StoreMatchingOffersDemands,
} from '@stores/_slices/matching_offers_demands';
import {
	offersReducer,
	StoreOffers,
} from '@stores/_slices/offers';
import {
	OffersEntryJsonStore,
	offersEntryReducer,
} from '@stores/_slices/offers_entry';
import {
	specificationOffersReducer,
	StoreCollectionSpecificationOffers,
} from '@stores/_slices/specification_offers';
import {
	specificationsReducer,
	StoreSpecifications,
} from '@stores/_slices/specifications';
import {
	statusMsgsReducer,
	StoreStatusMsgsInstance,
} from '@stores/_slices/status_msgs';
import {
	StoreToastMsgsInstance,
	toastMsgsReducer,
} from '@stores/_slices/toast_msgs';
import {
	GlobalUser,
	userReducer,
} from '@stores/_slices/user';

export interface ReducerInstance {
	app?: AppState;
	companies?: CompaniesState;
	companyBuildings?: CompanyBuildingsState;
	demands?: StoreDemands;
	device?: DeviceSliceInstance;
	managers?: CompanyManagersState;
	map?: MapSliceInstance;
	matchings_offers_demands?: StoreMatchingOffersDemands;
	offers?: StoreOffers;
	offers_entry?: OffersEntryJsonStore;
	specifications?: StoreSpecifications;
	specification_offers?: StoreCollectionSpecificationOffers;
	status_msgs?: StoreStatusMsgsInstance;
	toast_msgs?: StoreToastMsgsInstance;
	user?: GlobalUser;
}
export const reducers = {
	app: appReducer,
	companies: companiesReducer,
	companyBuildings: companyBuildingsReducer,
	demands: demandsReducer,
	device: deviceReducer,
	managers: companyManagersReducer,
	map: mapReducer,
	matchings_offers_demands: matchingOffersDemandsReducer,
	offers: offersReducer,
	offers_entry: offersEntryReducer,
	specification_offers: specificationOffersReducer,
	specifications: specificationsReducer,
	status_msgs: statusMsgsReducer,
	toast_msgs: toastMsgsReducer,
	user: userReducer,
};
